import React from "react";

export function StatCard({ label, value, sub, accent = "violet", testid }) {
  const map = {
    violet: "from-violet-500/20 to-violet-500/5 text-violet-300",
    cyan: "from-cyan-500/20 to-cyan-500/5 text-cyan-300",
    emerald: "from-emerald-500/20 to-emerald-500/5 text-emerald-300",
    amber: "from-amber-500/20 to-amber-500/5 text-amber-300",
    slate: "from-white/10 to-white/5 text-slate-300",
  };
  return (
    <div data-testid={testid} className={`glass rounded-2xl p-5 bg-gradient-to-br ${map[accent]} card-hover`}>
      <div className="text-xs font-mono uppercase tracking-wide text-slate-400">{label}</div>
      <div className="font-display text-2xl font-bold text-white mt-1.5">{value}</div>
      {sub && <div className="text-xs text-slate-500 mt-1">{sub}</div>}
    </div>
  );
}

const BADGES = {
  New: "bg-slate-500/20 text-slate-300", Submitted: "bg-slate-500/20 text-slate-300",
  Contacted: "bg-blue-500/20 text-blue-300", Qualified: "bg-cyan-500/20 text-cyan-300",
  "Proposal Sent": "bg-violet-500/20 text-violet-300", Won: "bg-emerald-500/20 text-emerald-300",
  Lost: "bg-red-500/20 text-red-300", Duplicate: "bg-amber-500/20 text-amber-300",
  Rejected: "bg-red-500/20 text-red-300",
  pending: "bg-amber-500/20 text-amber-300", approved: "bg-cyan-500/20 text-cyan-300",
  paid: "bg-emerald-500/20 text-emerald-300", reversed: "bg-slate-500/20 text-slate-400",
  requested: "bg-amber-500/20 text-amber-300", under_review: "bg-blue-500/20 text-blue-300",
  cancelled: "bg-slate-500/20 text-slate-400",
};

export function Badge({ status }) {
  return <span className={`inline-block text-xs font-medium px-2.5 py-1 rounded-full capitalize ${BADGES[status] || "bg-white/10 text-slate-300"}`}>{(status || "").replace(/_/g, " ")}</span>;
}

export function EmptyState({ icon: Icon, title, hint }) {
  return (
    <div className="text-center py-16 text-slate-400">
      {Icon && <Icon className="w-10 h-10 mx-auto mb-3 opacity-40" />}
      <p className="font-medium text-slate-300">{title}</p>
      {hint && <p className="text-sm mt-1 opacity-70">{hint}</p>}
    </div>
  );
}
